"use client";
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import trueCircle from "@/public/images/trueCircle.svg";
import infoCircle from "@/public/images/infoCircle.svg";
import Image from "next/image";
import { useTranslate } from "@/components/base/providers/TranslateProv";

interface ApplicationRequirementsProps {
  item: any;
}

const ApplicationRequirements: React.FC<ApplicationRequirementsProps> = ({
  item,
}) => {
  const { locale } = useTranslate() as { locale: "ar" | "en" };

  const validRequirements = item?.application_requirement.filter(
    (parentRequirement: any) =>
      parentRequirement.name[locale] &&
      parentRequirement.requirements &&
      parentRequirement.requirements[locale]?.length > 0
  );

  if (!validRequirements || validRequirements.length === 0) {
    return null;
  }

  return (
    <>
      <p className="text-25 text-[#141522] font-[600] text-center mb-10">
        {locale === "ar"
          ? `متطلبات التقديم لـ ${item.name.ar}`
          : `Application requirements to ${item.name.en}`}
      </p>
      <Accordion
        type="single"
        collapsible
        className="w-full"
        defaultValue="item-1"
      >
        {validRequirements.map((parentRequirement: any, index: number) => (
          <AccordionItem
            key={index}
            value={`item-${index + 1}`}
            className="mb-5 p-5 border border-[#EBEBEB] rounded-[15px]"
          >
            <AccordionTrigger className="text-[23px] text-textDark font-[500] border-b border-b-[#EBEBEB] mb-5">
              {parentRequirement.name[locale]}
            </AccordionTrigger>
            <AccordionContent
              className="rounded-[15px] bg-[#fcfcfc] border border-[#EBEBEB] p-5"
              style={{ boxShadow: "0px 4px 54px 0px rgba(0, 0, 0, 0.05)" }}
            >
              {parentRequirement.requirements[locale].map(
                (requirement: any, index: number) => (
                  <div className="flex items-center gap-3 my-4" key={index}>
                    <Image src={trueCircle} alt="fire" />
                    <p className="text-16 text-[#6C7278]">{requirement}</p>
                  </div>
                )
              )}
              {parentRequirement.note?.[locale] && (
                <div className="p-5 bg-[#F1F6FD] border border-[#A7C5FD] flex flex-col gap-4 items-center justify-center rounded-[10px]">
                  <Image src={infoCircle} alt="fire" />
                  <p className="text-16 text-descriptionText text-center">
                    {parentRequirement.note[locale]}
                  </p>
                </div>
              )}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
};

export default ApplicationRequirements;
